module.exports = __webpack_public_path__ + "img/South Sudan.21f63498.svg";